/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scheduledDependencyResponseSchema } from './scheduledDependencyResponseSchema';

export const paginationDocumentScheduledDependencyResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(scheduledDependencyResponseSchema);
  },
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
